import { marketingTranslations } from "@/features/marketing/marketing-copy";
import { LOCALE_TAG, type Locale, type PageLocale } from "@/lib/locales";
import { seedTranslations, translations } from "./index";
import type { LocaleMessages } from "./locales/types";

/** Each language is a chunk of its own, downloaded only by that language's pages. */
const LOADERS: Readonly<Record<Locale, () => Promise<{ messages: LocaleMessages }>>> = {
  nb: () => import("./locales/nb"),
  de: () => import("./locales/de"),
  es: () => import("./locales/es"),
  fr: () => import("./locales/fr"),
  ru: () => import("./locales/ru"),
  zh: () => import("./locales/zh"),
};

const loading = new Map<Locale, Promise<void>>();

/**
 * Fill the translation tables of `locale` before one of its pages renders (src/main.tsx on the first page, the `/$lang`
 * route on every later one). English needs nothing; a language loads once, and a failed download is tried again next time.
 */
export function loadLocale(locale: PageLocale): Promise<void> {
  if (locale === "en") return Promise.resolve();
  let pending = loading.get(locale);
  if (!pending) {
    pending = LOADERS[locale]().then(({ messages }) => {
      const tag = LOCALE_TAG[locale];
      Object.assign(translations[tag]!, messages.app);
      Object.assign(marketingTranslations[tag]!, messages.marketing);
      Object.assign(seedTranslations[tag]!, messages.seeds);
    });
    pending.catch(() => loading.delete(locale));
    loading.set(locale, pending);
  }
  return pending;
}
